module.exports = __webpack_public_path__ + "static/media/logo-alzheimer.7ffdfc82.png";